import "./css/App.css";
import Header from "../src/frontend/components/Header";
import Footer from "../src/frontend/components/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./frontend/components/ScrollToTop";
import LandingPage from "./frontend/pages/LangingPage";
import AboutUs from "./frontend/pages/AboutUs";
import ServicesPage from "./frontend/pages/Services";
import ContactUsPage from "./frontend/pages/ContactUs";
import PrivacyPage from "./frontend/pages/PrivacyPolicy";
import BlogsPage from "./frontend/pages/Blogs";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<LandingPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/blogs" element={<BlogsPage/>} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;